/* TODO: I want buttons for each of the source code examples, that 
interact with the source code panel (currently in the turing_viz
component but should be moved later) and copy-past the example's 
source code into the source code panel.

*/

import React from "react";
import Example from "../example/example";

class ExamplesContainer extends React.Component {
  state = {
    examples: [
      {
        key: 1,
        id: 1,
        title: "3-state busy beaver",
        description:
          "When given a blank input, the following Turing machine prints six 1's onto the tape and halts. It's impossible for any other Turing machine to print a longer string of 1's to the tape, unless it has a larger number of states, or runs forever. The maximum for 4 states is 13. The maximum for 5 states is at least 4098. The maximum for 6 states is at least 3.5e18267 (that's scientific notation for a number over 18 thousand digits long).",
        sourceCode: `$A;
$;
in A _ out B 1 right;
in A 1 out C 1 left;
in B _ out A 1 left;
in B 1 out B 1 right;
in C _ out B 1 left;
in C 1 out halt 1 right;`,
      },

      {
        key: 2,
        id: 2,
        title: "Binary increment",
        description:
          "This Turing machine adds one to a number given in binary. For example, 11 + 1 = (1011)_2 + 1 = (1100)_2, so the machine should halt with `1100` written on the tape when started with `1011`.",
        sourceCode: `$right;
$10011; 
in right 0 out right 0 right;
in right 1 out right 1 right;
in right _ out carry _ left;
in carry 0 out done 1 left;
in carry 1 out carry 0 left;
in carry _ out halt 1 left;`,
      },

      {
        key: 3,
        id: 3,
        title: "Palindrome checker",
        description:
          "The following Turing machine accepts a string of a's and b's if it's a palindrome, otherwise it halts in the `reject` state.",
        sourceCode: `$start; 
$abababa;
in start a out memoryA _ right; 
in start b out memoryB _ right; 
in start _ out accept _ right; 

in memoryA a out memoryA a right; 
in memoryA b out memoryA b right; 
in memoryA _ out matchA _ left; 

in memoryB a out memoryB a right; 
in memoryB b out memoryB b right; 
in memoryB _ out matchB _ left; 

in matchA a out back _ left; 
in matchA b out reject b right; 
in matchA _ out accept _ right; 

in matchB a out reject a right; 
in matchB b out back _ left; 
in matchB _ out accept _ right; 

in back a out back a left; 
in back b out back b left; 
in back _ out start _ right;`,
      },
      {
        key: 4,
        id: 4,
        title: "Finite state automata",
        description: `A finite-state automata can be viewed as a Turing machine which never edits the tape and always moves right. This machine recognizes the regular language a*b* (any number of a's followed by any number of b's). In contrast, the palindrome language in the previous example is not regular, meaning there is no finite-state automata recognizing it.`,
        sourceCode: `$A;
$aaaaabbb;
in A _ out accept _ right;
in A a out A a right;
in A b out B b right;
in B _ out accept _ right;
in B a out reject a right;
in B b out B b right;`,
      },
    ],
  };

  render() {
    const { setSourceCode, lastChanger, setLastChanger } = this.props;
    return (
      <React.Fragment>
        <h3>
          <span className="badge m-2">More examples:</span>
        </h3>
        <p className="m-2">
          Try some of these example programs, or edit your own in the Code box
          above!
        </p>

        {this.state.examples.map((example) => (
          <React.Fragment>
            <span>
              <Example
                key={example.id}
                id={example.id}
                sourceCode={example.sourceCode}
                title={example.title}
                description={example.description}
                setSourceCode={setSourceCode}
                setLastChanger={setLastChanger}
                lastChanger={lastChanger}
              />
            </span>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }
}

export default ExamplesContainer;
